import { useContext } from 'react'
import { SelectedStoreContext } from './SelectedStoreContext.jsx'

export function useSelectedStore() {
  const ctx = useContext(SelectedStoreContext)
  if (!ctx) {
    throw new Error('useSelectedStore must be used within SelectedStoreProvider')
  }
  return ctx
}
